var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isValidIcon)?_c('svg',{staticClass:"icon-header__icon",class:{ [`icon--${_vm.color}`]: _vm.color },attrs:{"width":_vm.dimensions.width,"height":_vm.dimensions.height,"viewBox":_vm.dimensions.viewBox,"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":_vm.path,"fill-rule":_vm.fillRule,"fill":"fff"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }